import { GridColumns, GridValueGetterParams } from "@mui/x-data-grid";
import { SalaryDtos } from "../../../Component/Model/Dto/Salaries";
import { DateFormatter } from "../../../Component/Model/helpers";
import { decimalFormatter } from "../../../Helpers/DecimalFormatter";
import { Individual } from "../../../Component/Model/Dto/Individual";

const colMonthWidth: number = 200;
const colSalariesWidth: number = 150;
export const columns: GridColumns = [
  {
    field: 'salaryDate', headerName: 'Month', editable: false, width: colMonthWidth, type: 'string', sortable: false,
    valueGetter: (params: GridValueGetterParams) => {
      return DateFormatter((params.row as SalaryDtos.ISalaryResponse).salaryDate.toString(), 'MMMM');
    }
  },
  {
    field: 'ctc', headerName: 'CTC', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    valueFormatter: ({ value }) => "N/A"
  },
  {
    field: 'fixed', headerName: 'FIXED', editable: true, width: colSalariesWidth, type: 'number', sortable: false,
    valueFormatter: ({ value }) => decimalFormatter(value)
  },
  {
    field: 'variable', headerName: 'VARIABLE', editable: true, width: colSalariesWidth, type: 'number', sortable: false,
    valueFormatter: ({ value }) => decimalFormatter(value)
  },

];
export const aggregateColumns: GridColumns = [
  {
    field: 'salaryDate', headerName: 'Month', editable: false, width: colMonthWidth, type: 'string', sortable: false,
  },
  {
    field: 'ctc', headerName: 'CTC', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    valueFormatter: ({ value }) => decimalFormatter(value)
  },
  {
    field: 'fixed', headerName: 'FIXED', editable: false, width: colSalariesWidth, type: 'number', sortable: false,
    valueFormatter: ({ value }) => decimalFormatter(value)
  },
  {
    field: 'variable', headerName: 'VARIABLE', editable: false, width: colSalariesWidth, type: 'number', sortable: false,
    valueFormatter: ({ value }) => decimalFormatter(value)
  },
];

export const annualizedColumns: GridColumns = [
  {
    field: 'salaryDate', headerName: 'Month', editable: false, width: colMonthWidth, type: 'string', sortable: false,
  },
  {
    field: 'ctc', headerName: 'CTC', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
  },
  {
    field: 'fixed', headerName: 'FIXED', editable: false, width: colSalariesWidth, type: 'number', sortable: false,
    valueFormatter: ({ value }) => decimalFormatter(value)
  },
  {
    field: 'variable', headerName: 'VARIABLE', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
  },

];


export const getIndividualSalaryColumns = (isEditable: boolean): GridColumns => [
  {
    field: 'displayDate', headerName: 'Month', editable: false, width: colMonthWidth, type: 'string', sortable: false,
    valueGetter: (params: GridValueGetterParams) => {
      return DateFormatter((params.row as Individual.Salary).displayDate.toString(), 'MMMM');
    }
  },
  {
    field: 'salary', headerName: 'CTC', editable: isEditable, width: colSalariesWidth, type: 'number', sortable: false,
    valueFormatter: ({ value }) => decimalFormatter(value)
  },
  {
    field: 'fixed', headerName: 'Fixed', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    valueFormatter: ({ value }) => "N/A"
  },
  {
    field: 'variable', headerName: 'Variable', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    valueFormatter: ({ value }) => "N/A"
  }
];

export const aggregateIndividualColumns: GridColumns = [
  {
    field: 'displayDates', headerName: 'Month', editable: false, width: colMonthWidth, type: 'string', sortable: false,
    valueFormatter: ({ value }) => value
  },
  {
    field: 'salary', headerName: 'CTC', editable: false, width: colSalariesWidth, type: 'number', sortable: false,
    valueFormatter: ({ value }) => decimalFormatter(value)
  },
  {
    field: 'fixed', headerName: 'Fixed', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    valueFormatter: ({ value }) => "N/A"
  },
  {
    field: 'variable', headerName: 'Variable', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    valueFormatter: ({ value }) => "N/A"
  }
];


export const annualizedIndividualColumns: GridColumns = [
  {
    field: 'displayDates', headerName: 'Month', editable: false, width: colMonthWidth, type: 'string', sortable: false,
  },
  {
    field: 'salary', headerName: 'CTC', editable: false, width: colSalariesWidth, type: 'number', sortable: false,
    valueFormatter: ({ value }) => decimalFormatter(value)
  },
  {
    field: 'fixed', headerName: 'Fixed', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    valueFormatter: ({ value }) => "N/A"
  },
  {
    field: 'variable', headerName: 'Variable', editable: false, width: colSalariesWidth, type: 'string', sortable: false,
    valueFormatter: ({ value }) => "N/A"
  }
];